//Quick View
$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
});
function quickView() {
  var cartNotification = document.querySelector('cart-notification');
  var timeout_change = null;

  var lang_subfolder = "";
  var add_to_cart_label = "Add to Cart";
  var has_been_added_label = "has been added to your cart.";
  var location_pathname_splits = location.pathname.split('/');
  var click_here_to_view_label = "Click here to view your cart.";
  var error_label = "Error:";
  var sold_out_label = "Sold Out";
  var unavailable_label = "Unavailable";
  if (location_pathname_splits.length > 1) {
    var potential_lang_subfolder = location_pathname_splits[1].toLowerCase();
    if (potential_lang_subfolder == "fr") {
      lang_subfolder = "/fr";
      add_to_cart_label = "Ajouter au panier";
      has_been_added_label = "a été ajouté à ton panier.";
      click_here_to_view_label = "Cliquer ici pour accéder à votre panier.";
      error_label = "Erreur :";
      sold_out_label = "Rupture de stock";
      unavailable_label = "Non disponible";
    }
  }

  $(".quick-view").click(function () {

    if ($('#quick-view').length == 0){
      $("body").append('<div id="quick-view"></div>');
    }
    var product_handle = $(this).data('handle');
    var variant_id = $(this).data('vid');
    var initial_variant_options = [];
    for (let i = 1; i <= 3; i++) {
      var variant_option = $(this).data('option' + i);
      if (variant_option) {
        initial_variant_options.push(variant_option);
      }
    }
    $("#quick-view").attr('class', product_handle);

    /* start get product handle json */
    jQuery.getJSON(lang_subfolder + '/products/' + product_handle + '.json', function (response) {
      var product = response.product;
      var title = product.title;
      var price = 0;
      var original_price = 0;
      var desc = product.body_html;
      var images = product.images;
      var variants = product.variants;
      var template = product.template_suffix;
      var options = product.options;
      var url = '/products/' + product_handle;
      $('.qv-product-title').text(title);
      $('.qv-product-description').html(desc);
      $('.view-product').attr('href', lang_subfolder + url);
      if (template == 'quick-view') {
        $('.view-product').hide();
      }
      var imageCount = $(images).length;
      $(images).each(function (i, image) {
        var image_variant_ids = '';
        if (image.variant_ids && image.variant_ids.length > 0) {
          var image_variant_ids = ' data-variant-ids="' + image.variant_ids.join('&') + '"';
        }
        if (i == imageCount - 1) {
          var image_embed = '<div' + image_variant_ids + '><img class="lazy2" data-src="' + image.src + '" src="' + image.src + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
          $('.qv-product-images').slick({
            'dots': true,
            'arrows': true,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');
        } else {
          image_embed = '<div' + image_variant_ids + '><img class="lazy2" data-src="' + image.src + '" src="' + image.src + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
        }
      });

      $(options).each(function (i, option) {
        var opt = option.name;
        var option_name = opt;
        var selectClass = '.option.' + opt.toLowerCase();

        $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + option_name + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
        $(option.values).each(function (i, value) {
          $('.option.' + opt.toLowerCase()).append('<option value="' + value.replace('"', '') + '">' + value + '</option>');
        });
      });

      $(variants).each(function (i, v) {
        if (v.available == false) {
          $('.qv-add-button').prop('disabled', true).val(sold_out_label);
          $('.qv-add-to-cart').hide();
          $('.qv-product-price').text(sold_out_label).show();
          return true
        } else {
          price = v.price;
          original_price = v.compare_at_price;
          $('.qv-product-price').text('$' + price);
          if (original_price > 0) {
            $('.qv-product-original-price').text('$' + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }
          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return false
        }
      });
    });
    /* end get product handle json */

    $(document).on("change", "#quick-view select", function () {
      var selectedOptions = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
      product_handle = $('#quick-view').attr('class');
      jQuery.getJSON(lang_subfolder + '/products/' + product_handle + '.js', function (product) {
        var found_same_variant = false;
        $(product.variants).each(function (i, v) {
          var test_options = v.options.join(" / ");
          test_options = test_options.replace('"', '');
          if (test_options == selectedOptions) {
            found_same_variant = true;
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_inv = v.inventory_management;
            
            // switch to image if image exists
            var v_id = v.id;
            var variant_slide = $('.qv-product-images .slick-slide[data-variant-ids*="' + v_id + '"]');
            var variant_current_slide = $(variant_slide).hasClass('slick-current');
            if (variant_slide && !variant_current_slide && $(variant_slide).data('variant-ids')) {
              var slide_index = $(variant_slide).data('slick-index');
              $('.qv-product-images').slick('slickGoTo', slide_index);
            }

            $('.qv-product-price').text('$' + price);
            $('.qv-product-original-price').text('$' + original_price);
            if (original_price > 0) {
              $('.qv-product-original-price').text('$' + original_price).show();
            } else {
              $('.qv-product-original-price').hide();
            }
            if (v_inv == null) {
              $('.qv-add-button').prop('disabled', false).val(add_to_cart_label);
            } else {
              if (v.available == false) {
                $('.qv-add-button').prop('disabled', true).val(sold_out_label);
              } else {
                $('.qv-add-button').prop('disabled', false).val(add_to_cart_label);
              }
            }
          }
        });
        if (found_same_variant == false) {
          $('.qv-add-button').prop('disabled', true).val(unavailable_label);
        }
      });
    });

    $.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '100%',
      height: '100%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
        $(document).on("click", ".qv-add-button", function () {
          var qty = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          $('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = $(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + $(this).val();
            }
          });
          jQuery.getJSON(lang_subfolder + '/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              var variant_title = v.options.join(" / ");
              variant_title = variant_title.replace('"', '');
              if (variant_title == selectedOptions) {
                var_id = v.id;
                processCart();
              }
            });
          });
          function processCart() {
            jQuery.post('/cart/add', {
              quantity: qty,
              form_type: "product",
              utf8: "✓",
              id: var_id,
              sections: "cart-notification-product,cart-notification-button,cart-icon-bubble",
              sections_url: "/products/" + product_handle
            },
              null,
              "json"
            ).done(function($xhr) {
              cartNotification.renderContents($xhr);
              $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' ' + has_been_added_label + ' <a href="' + lang_subfolder + '/cart">' + click_here_to_view_label + '</a>');
            })
            .fail(function($xhr) {
              var data = $xhr.responseJSON;
              $('.qv-add-to-cart-response').addClass('error').html('<span><b>' + error_label + ' </b>' + data.description);
            });
          }
        });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });

    if (timeout_change) {
      clearTimeout(timeout_change);
    }
    timeout_change = setTimeout(() => {
      for (let i = 0; i < initial_variant_options.length; i++) {
        const initial_variant_option = initial_variant_options[i];
        const variant_option_selector = "#quick-view select.option-" + i;
        $(variant_option_selector).val(initial_variant_option);
        if (i == initial_variant_options.length - 1) {
          $(variant_option_selector).change();
        }
      }
    }, "100");

  });
};
$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});